import { useEffect, useState } from "react";
import { TaskTag, TaskTagTask } from "../interfaces/Task";
import { t } from "i18next";
import { Button, Form } from "react-bootstrap";
import { safeJsonParse } from "../../utils/api";

interface TaskTagsProps {
    taskId: string;
}

export function TaskTags(props: TaskTagsProps) {
    const [tags, setTags] = useState<TaskTag[]>([]);
    const [tagsLoaded, setTagsLoaded] = useState(false);
    const [taskTags, setTaskTags] = useState<TaskTagTask[]>([]);
    const [taskTagsLoaded, setTaskTagsLoaded] = useState(false);

    useEffect(() => {
        const userId = localStorage.getItem('userId') ?? null;

        if (userId) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/' + userId, requestOptions)
                .then(response => {
                    return safeJsonParse(response);
                })
                .then(data => {
                    setTags(data);
                    setTagsLoaded(true);
                });
            fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/task/' + props.taskId, requestOptions)
                .then(response => {
                    return safeJsonParse(response);
                })
                .then(data => {
                    setTaskTags(data);
                    setTaskTagsLoaded(true);
                });
        }
    }, []);

    const handleTagAdd = (event: any) => {
        event.preventDefault();

        const userId = localStorage.getItem('userId') ?? null;
        const tagName = event.target.previousElementSibling.value;
        if (userId) {
            const index = tags.findIndex((t: TaskTag) => t.name == tagName);
            if (index !== -1) {
                alert(t("This tag already exists."));
            } else {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        name: tagName,
                        userId: userId
                    })
                };
                fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/', requestOptions)
                    .then(response => {
                        return safeJsonParse(response);
                    })
                    .then(data => {
                        const newTags = tags.map((t: TaskTag) => {return t;});
                        newTags.push(data);
                        setTags(newTags);
                    });
            }
        }
    }

    const handleDeleteTag = (event: any) => {
        event.preventDefault();

        if (window.confirm(t("Are you sure you want to delete this tag? This action cannot be undone."))) {
            const tagId = event.currentTarget.dataset.id;
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/' + tagId, requestOptions)
                .then(response => {
                    const newTags = tags.filter((t: TaskTag) => t._id != tagId);
                    setTags(newTags);
                });
        }
    }

    const handleSelectTag = (event: any) => {
        event.preventDefault();
        const selected = event.currentTarget.dataset.selected;
        const tagId = event.currentTarget.dataset.id;
        if (selected == 0) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    tag_id: tagId,
                    task_id: props.taskId
                })
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/assign', requestOptions)
                .then(response => {
                    return safeJsonParse(response);
                })
                .then(data => {
                    const newTaskTags = taskTags.map((tt: TaskTagTask) => {return tt;});
                    newTaskTags.push(data);
                    setTaskTags(newTaskTags);
                });
        } else {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    tag_id: tagId,
                    task_id: props.taskId
                })
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task-tags/unassign', requestOptions)
                .then(response => {
                    return safeJsonParse(response);
                })
                .then(data => {
                    const newTaskTags = taskTags.filter((tt: TaskTagTask) => tt._id != data._id);
                    setTaskTags(newTaskTags);
                });
        }
    }

    const isSelected = (id: string) => {
        const index = taskTags.findIndex((tt: TaskTagTask) => tt.tagId == id);
        if (index !== -1) {
            return 1;
        } else {
            return 0;
        }
    }
    
    return (<div className="task-tags-list-container">
        <div className="label">
            { t("Tags") }
        </div>
        { tagsLoaded && taskTagsLoaded &&
            <div className="tags-list">
                { tags.map((t: TaskTag) => {
                    return <div key={ 'task-tag-' + t._id } className="task-tag-item"
                        onClick={ handleSelectTag } data-id={ t._id } data-selected={ isSelected(t._id) }>
                        <a href="#" onClick={ handleDeleteTag } data-id={ t._id }></a>
                        { t.name }
                    </div>
                })}
            </div>
        }
        <div className="add-tags">
            <Form.Control type="text" name="tag"
                placeholder={ t("Write a tag name") } />
            <Button onClick={ handleTagAdd }>{ t("Add") }</Button>
        </div>
    </div>);
}